





















/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConsumptionAndEmissionData } from '@/constants/interfaces';
import { DisplayData, DisplayItem } from '@/constants/types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { brandContext } from '@/constants/locales';
import 'core-js/fn/array/flat-map';

const propertyIsNotUndefined = <T extends unknown>(
  keyValuePair: [string, T | undefined]
): keyValuePair is [string, T] => !!keyValuePair[1];

const byCycleDescFuelAscCategoryAsc = (a: DisplayItem, b: DisplayItem) =>
  a.cycle.localeCompare(b.cycle, 'en') ||
  a.fuel.localeCompare(b.fuel, 'en') ||
  a.category.localeCompare(b.category, 'en');

const showOnlyChangedCycleAndFuel = (item: DisplayItem, i: number, items: DisplayItem[]) => {
  if (i === 0) return item;
  const cycleHasChanged = items[i - 1].cycle !== item.cycle;
  const fuelHasChanged = items[i - 1].fuel !== item.fuel;
  return {
    ...item,
    cycle: cycleHasChanged ? item.cycle : '',
    fuel: cycleHasChanged || fuelHasChanged ? item.fuel : ''
  };
};

const transformToDisplay = (fuelToCae: any): DisplayData => {
  const data = {
    eec: fuelToCae.eec,
    // Adjust parsing of fuels as soon as old versions of giveaways are expired or migrated.
    items: Object.entries(fuelToCae.fuels ? fuelToCae.fuels : fuelToCae).flatMap(([fuel, cae]) =>
      Object.entries(cae as any)
        .filter(propertyIsNotUndefined)
        .flatMap(([category, cycles]) =>
          Object.entries(cycles as any).map(([cycle, cycleData]) => ({
            unit: cycleData ? (cycleData as any).unit : '',
            value: cycleData ? (cycleData as any).subcycles.combined : NaN,
            fuel,
            category,
            cycle: cycle.toUpperCase()
          }))
        )
    )
  };

  data.items = data.items.sort(byCycleDescFuelAscCategoryAsc).map(showOnlyChangedCycleAndFuel);

  return data;
};

@Component
export default class Consumption extends Vue {
  @Prop({ type: Object }) consumption!: {
    consumptionAndEmissionData: ConsumptionAndEmissionData;
    createdAt: string;
  };

  get brandContext(): string {
    return brandContext;
  }

  locale(translationKey: string) {
    const fullKey = `consumption.${translationKey}`;
    const translation = this.$t(fullKey);
    return translation === fullKey ? translationKey : translation;
  }

  getCategoryTranslationKey(category: string, fuel: string) {
    if (category === 'consumption') {
      if (fuel === 'ELECTRICAL') {
        return 'consumption.electrical';
      }
      return 'consumption.fuel';
    }
    return category;
  }

  scrollToDatNotice() {
    // eslint-disable-next-line no-unused-expressions
    document.querySelector('#dat-notice')?.scrollIntoView({ behavior: 'smooth' });
  }

  get displayData(): DisplayData {
    if (!this.consumption.consumptionAndEmissionData) {
      return {
        items: []
      };
    }
    return transformToDisplay(this.consumption.consumptionAndEmissionData);
  }
}
